import * as types from '../../../store/mutation-types';
import store from '../../../store';
import logger from "../../logger";

export default class ServiceOrderSummary {

  constructor(service)
  {
    this.monthly = 'monthly';
    this.service = service;
    this.service_class_name = service.service_class_model.name;
  }

  _sum(array) {
    let total = 0;
    for (let item of array) {
      total += Number(item);
    }
    return total;
  }

  getMonthlyRate(billing_item) {
    return billing_item.rate_period === this.monthly ? billing_item.rate : 0.;
  }

  serviceOptionMonthlyXMissionFeesTotal(service_option) {
    let fees = service_option.billing.fees.filter(x => x.provider.name === 'xmission');
    return this._sum(fees.map((x) => this.getMonthlyRate(x)));
  }

  serviceMonthlyXMissionFeesTotal() {
    let fees = this.service.billing.fees.filter(x => x.provider.name === 'xmission');
    return this._sum(fees.map((x) => this.getMonthlyRate(x)));
  }

  serviceOptionMonthlyXMissionPricesTotal(service_option) {
    let prices = service_option.billing.prices.filter(x => x.provider.name === 'xmission');
    return this._sum(prices.map((x) => this.getMonthlyRate(x)));
  }

  serviceMonthlyXMissionPricesTotal() {
    let prices = this.service.billing.prices.filter(x => x.provider.name === 'xmission');
    return this._sum(prices.map((x) => this.getMonthlyRate(x)));
  }

  serviceOptionMonthlyPromosTotal(service_option) {
    return this._sum(service_option.billing.promos.map((x) => this.getMonthlyRate(x)));
  }

  grossServiceOptionXMissionMonthlyCost(service_option) {
    return this.serviceOptionMonthlyXMissionFeesTotal(service_option) + this.serviceOptionMonthlyXMissionPricesTotal(service_option);
  }

  grossServiceXMissionMonthlyCost() {
    return this.serviceMonthlyXMissionFeesTotal() + this.serviceMonthlyXMissionPricesTotal();
  }

  grossCostsPerProvider(service_option) {
    let costs_by_provider = {};
    let items = this.service.billing.prices.concat(this.service.billing.fees).concat(service_option.billing.prices).concat(service_option.billing.fees);
    logger.debug('items: ', items)
    for (let item of items) {
      if (!(item.provider.name in costs_by_provider)) {
        costs_by_provider[item.provider.name] = {cost: 0, provider: item.provider};
      }
      costs_by_provider[item.provider.name].cost += item.rate;
    }
    return costs_by_provider;
  }

  emptyCart() {
    store.commit(types.EMPTY_CART);
  }

  _getBillableItemDetails(item) {
    return {...item, service_class: this.service_class_name};
  }

  addToCart(item) {
    store.commit(types.ADD_TO_CART, this._getBillableItemDetails(item));
  }

  _addBillingItemsToContainer(billing_items, adder) {
    for (let billing_item of billing_items) {
      adder(billing_item)
    }
  }

  addServiceToCart(fresh=false){
    if (fresh){
      this.emptyCart();
    }
    this._addBillingItemsToContainer(this.service.billing.prices, this.addToCart.bind(this));
    this._addBillingItemsToContainer(this.service.billing.fees, this.addToCart.bind(this));
    this._addBillingItemsToContainer(this.service.billing.promos, this.addToCart.bind(this));
    store.commit(types.CALCULATE_CART);
  }

  addServiceOptionToCart(service_option) {
    this._addBillingItemsToContainer(service_option.billing.prices, this.addToCart.bind(this));
    this._addBillingItemsToContainer(service_option.billing.fees, this.addToCart.bind(this));
    this._addBillingItemsToContainer(service_option.billing.promos, this.addToCart.bind(this));
    store.commit(types.CALCULATE_CART);
  }

  removeServiceFromCart() {
    for (let item of this.service.billing.prices.concat(this.service.billing.fees).concat(this.service.billing.promos)) {
      store.commit(types.REMOVE_FROM_CART, item.item_type);
    }
    store.commit(types.CALCULATE_CART);
  }

  removeServiceOptionFromCart(service_option) {
    for (let item of service_option.billing.prices.concat(service_option.billing.fees).concat(service_option.billing.promos)) {
      store.commit(types.REMOVE_FROM_CART, item.item_type);
    }
    store.commit(types.CALCULATE_CART);
  }

}



// WEBPACK FOOTER //
// ./src/lib/ssu/input_models/service-order-summary.js